import { Grid } from '@material-ui/core'
import React from 'react'
import { PaperClipOutlined } from '../../../../Components/Icons/Icons'
import { DocumentsProposalFragment } from './Documents.generated-types'

interface CompProps {
  proposal: DocumentsProposalFragment
}

export const Documents: React.FC<CompProps> = ({ proposal: { documents, space: { spaceDocuments } } }) => {
  const documentsList = documents.map((doc, i) => {
    return (
      <Grid item xs={12} key={i}>
        <a href={`https://${doc.URL}`} rel='noreferrer' target='_blank' style={{ color: '#1f1f1f', display: 'inline-flex', alignItems: 'center' }}>
          <PaperClipOutlined viewBox="0 0 16 16"/>
          <span style={{ textDecoration: 'underline', paddingLeft: 6 }}>
            {`${doc.filename}`}
          </span>
        </a>
      </Grid>
    )
  })

  const spaceDocumentsList = spaceDocuments.map((doc, i) => {
    return (
      <Grid item xs={12} key={i}>
        <a href={`${doc.url}`} rel='noreferrer' target='_blank' style={{ color: '#1f1f1f', display: 'inline-flex', alignItems: 'center' }}>
          <PaperClipOutlined viewBox="0 0 16 16"/>
          <span style={{ textDecoration: 'underline', paddingLeft: 6 }}>
            {`${doc.filename}`}
          </span>
        </a>
      </Grid>
    )
  })

  return (
    <Grid container>
      {documentsList}
      {spaceDocumentsList}
    </Grid>
  )
}
